import React from 'react'
import PropTypes from 'prop-types'
import { FormattedMessage, defineMessages } from 'react-intl'
import { useSelector } from 'react-redux'
import {
  selectCustomerIsRealEstateAgent,
  selectCustomerFirstName
} from 'src/store/selectors/customerProfile'
import { Format } from 'src/Components'

const TUNE_YOUR_VALUE_MESSAGES = defineMessages({
  head_not_rea: {
    id: 'TYV.valuation.outreach.head.lo',
    defaultMessage: 'Want an expert opinion?'
  },
  head_extreme_high: {
    id: 'TYV.valuation.outreach.head.extreme.high',
    defaultMessage: 'Think your home is worth more?'
  },
  head_extreme_low: {
    id: 'TYV.valuation.outreach.head.extreme.low',
    defaultMessage: 'Think your home is worth less?'
  },
  body_not_rea: {
    id: 'TYV.valuation.outreach.body.lo',
    defaultMessage:
      '{name} can ask a local agent if {value} looks good for your area'
  },
  body_not_rea_extreme: {
    id: 'TYV.valuation.outreach.body.lo.extreme',
    defaultMessage:
      '{name} can ask a local agent to do a quick home value analysis for you.'
  },
  body_rea: {
    id: 'TYV.valuation.outreach.body.rea',
    defaultMessage:
      '{name} is happy to check your tuned value and reach out with any guidance'
  },
  body_rea_extreme: {
    id: 'TYV.valuation.outreach.body.rea.extreme',
    defaultMessage:
      'We can ask {name} to do a quick home value analysis for you'
  }
})

export const Head = ({ extreme, high, low }) => {
  const isREA = useSelector(selectCustomerIsRealEstateAgent)
  let key

  if (!isREA && !extreme) {
    key = 'head_not_rea'
  } else if (low) {
    key = 'head_extreme_low'
  } else if (high) {
    key = 'head_extreme_high'
  } else if (isREA) {
    return ''
  }
  return <FormattedMessage {...TUNE_YOUR_VALUE_MESSAGES[key]} />
}

export const Body = ({ extreme, amount }) => {
  const isREA = useSelector(selectCustomerIsRealEstateAgent)
  const customerFirstName = useSelector(selectCustomerFirstName)

  const key = `body_${!isREA ? 'not_rea' : 'rea'}${extreme ? '_extreme' : ''}`

  const props = {
    ...TUNE_YOUR_VALUE_MESSAGES[key],
    values: {
      name: customerFirstName,
      value: <Format.Currency abbreviate value={amount} />
    }
  }

  return <FormattedMessage {...props} />
}

export const Copy = props => (
  <>
    <Head key='head' {...props} />
    <Body key='body' {...props} />
  </>
)

Head.propTypes = {
  extreme: PropTypes.bool,
  high: PropTypes.bool,
  low: PropTypes.bool
}

Body.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  extreme: PropTypes.bool
}

Copy.propTypes = {
  amount: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  extreme: PropTypes.bool
}

Copy.Head = Head
Copy.Body = Body

export default Copy
